import React from 'react';
import * as ReactDOM from "react-dom/client";
import {
    createBrowserRouter,
    RouterProvider,
} from "react-router-dom";
import './index.css';
import reportWebVitals from './reportWebVitals';
import SetOverview from './SetOverview/SetOverview';
import SetList from './SetList/SetList';
import StudyMode from "./StudyMode/StudyMode";
import BooksOverview from "./BooksOverview/BooksOverview";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const router = createBrowserRouter([
    {
        path: "/",
        element: <SetList/>,
    },
    {
        path: "/sets/:id",
        element: <SetOverview/>,
    },
    {
        path: "/sets/:id/study",
        element: <StudyMode/>,
    },
    {
        path: "/books/study",
        element: <StudyMode combined={true}/>,
    },
    {
        path: "/books",
        element: <BooksOverview/>,
    },
]);

export default ReactDOM.createRoot(document.getElementById("root")).render(
    <React.StrictMode>
        <RouterProvider router={router} />
    </React.StrictMode>
);

serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
